import { render, staticRenderFns } from "./RegisterThanks.vue?vue&type=template&id=11c8e1a5&"
import script from "./RegisterThanks.vue?vue&type=script&lang=js&"
export * from "./RegisterThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports